<template>
  <vue-slider
    v-model="value"
    :data="data"
    :data-label="'label'"
    :data-value="'value'"
    :lazy="true"
    :dot-size="20"
    :disabled="disabled"
    :step-style="{ display: 'none' }"
    :tooltip="hideTooltip || data.length === 0 || disabled ? 'none' : 'active'"
  />
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  components: {
    VueSlider,
  },
  model: {
    prop: 'selection',
    event: 'change',
  },
  props: {
    selection: {
      type: [Array, Number],
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    marks: {
      default: true,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideTooltip: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    value: {
      get() {
        if (this.data.length) return this.selection
        return null
      },
      set(to) {
        this.$emit('change', to)
      },
    },
  },
}
</script>

<style lang="stylus">
.vue-slider
  padding: 0 !important
  border-radius: 3px
  flex: 1 1 0%
  height: 6px !important
  margin: vw(20px) vw(40px)

  [layout="embedded"] &
    margin: vw(50px) vw(20px)

  .mobile &
    margin: vw(30px) vw(20px) vw(30px) vw(10px)

    +m-breakpoint(landscape)
      margin: vh(20px) vw(20px)

      [layout="embedded"] &
        margin: vh(20px) vw(20px)

  &.vue-slider-disabled
    opacity: .5

  > .vue-slider-rail
    background-color: rgba($blue-2, 0.2)

    .vue-slider-process
      background-color: rgba($blue-2, 0.4)

    .vue-slider-mark
      background-color: $blue-2
      margin-left: 3px !important
      width: 1px !important

      .vue-slider-mark-label
        display: none

      &:first-child,
      &:last-child
        .vue-slider-mark-label
          display: block

      &:last-child
        margin-left: -3px !important

        .vue-slider-mark-label
          display: block

    .vue-slider-dot-handle
      border: none
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12), 0 6px 13px rgba(0, 0, 0, 0.12)
      transition: box-shadow 0.25s ease-in-out

      &:hover
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25), 0 6px 13px rgba(0, 0, 0, 0.25)

      &:active
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4), 0 6px 13px rgba(0, 0, 0, 0.4)

    .vue-slider-dot-tooltip
      opacity: 1 !important
      visibility: visible !important

    .vue-slider-dot-tooltip-inner
      background-color: $blue-2
      border-color: $blue-2
      padding: 4px 6px;
      font-size 12px
</style>
